/**
 * Key used to store the login email in the storage.
 */
export const STORAGE_EMAIL_KEY = '@login:email';

/**
 * Prefix in the path when redirecting the operation to desktop.
 */
export const DESKTOP_PREFIX = '/:desktop:';
